import { Store } from '../../types/model';
import { Page } from '../../types/Seo';

export default function getEventListSeo(
  selectedStore: Store,
  _page: Page,
  t: Function
) {
  const url = window.location.href;
  const path = url.replace(/^https?:\/\//, '').split('/');

  const setOtherstoreName = () => {
    if (selectedStore !== undefined) {
      if (
        ((["jp", "kr"].includes(path[1]) && path[2] === "en") ||
          (path[1] === "ca" && path[2] === "fr"))
      ) {
        return selectedStore.storeOtherName;
      } else {
        return selectedStore.storeName;
      }

    }
    return '';
  };

  const title = selectedStore
    ? t('event.storePageTitle', { storeName: setOtherstoreName() })
    : t('event.pageTitle');

  const description = selectedStore
    ? 'storeEventCustomer.storeDescription'
    : 'storeEventCustomer.listDescription';

  const meta = [
    {
      name: 'description',
      content: t(description, { storeName: setOtherstoreName() })
    },
  ];

  const robots = [
    {
      name: 'robots',
      content: 'index, follow',
    },
  ];

  return {
    jsonLd: null,
    meta: [...meta, ...robots],
    title,
    canonicalPath: null,
  };
}
